import { AdminTool } from "./types";

export function isAdminTool(value?: string): value is AdminTool {
  return !!value && Object.values(AdminTool).includes(value as AdminTool);
}
